import { render, staticRenderFns } from "./ChartCol.vue?vue&type=template&id=3af2a81c&scoped=true"
import script from "./ChartCol.vue?vue&type=script&lang=ts"
export * from "./ChartCol.vue?vue&type=script&lang=ts"
import style0 from "./ChartCol.vue?vue&type=style&index=0&id=3af2a81c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2a81c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af2a81c')) {
      api.createRecord('3af2a81c', component.options)
    } else {
      api.reload('3af2a81c', component.options)
    }
    module.hot.accept("./ChartCol.vue?vue&type=template&id=3af2a81c&scoped=true", function () {
      api.rerender('3af2a81c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChartCol.vue"
export default component.exports